
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
//
//
//

// Declare Vue in the bootstrap file so we can make
// certain packages available to both the admin and the 'app' javascripts
// window.Vue = require('vue');
import Vue from 'vue';

// https://github.com/lokyoung/vuejs-paginate
import Paginate from 'vuejs-paginate';
Vue.component('paginate', Paginate);

// https://github.com/baianat/vee-validate
import VeeValidate, {Validator} from 'vee-validate';
Vue.use(VeeValidate, {
    events : 'change',
});


import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);

require('bootstrap-select');
require('bootstrap-datepicker');
import '../../node_modules/bootstrap-datepicker/dist/css/bootstrap-datepicker.css';

// Correct any field names etc here
const dictionary = {
    en: {
        attributes: {
            first_name: 'first name',
            last_name: 'last name',
            password_confirmation : 'confirm password',
            new_password_confirmation : 'confirm password',
            dob_day : 'day',
            dob_month : 'month',
            dob_year : 'year',
            learn_cricket : 'learn cricket',
            spirit_of_cricket : 'Spirit of Cricket',
            parent_consent: "parent consent",
            terms_and_conditions : "terms and conditions",
            card_name: "name on card",
            card_number: "card number",
            expiration_month : "expiration month",
            expiration_year : "expiration year",
            card_cvc : "cvc",
            'roles[]' : "roles",
            role_clubadmin : "club admin",
            role_umpire : "umpire",
            role_scorer : "scorer",
            role_coach : "coach",
            new_club_id : "new club",
            comeptition_id : 'competition',
            team_home_id : 'home team',
            team_away_id : 'away team',
            venue_id : 'venue'

        },
        custom: {
            address: {
                required_if: 'Your address is required. Enter your eircode and click Get Address',
            },
        }            
    },
};

Validator.localize(dictionary);

Vue.mixin({
    methods: {
        urlWithReturn(intended) {
            return intended + '?back=' + window.location.href;
        }
    }
})

$( document ).ready(function() {
    $.fn.selectpicker.Constructor.BootstrapVersion = '4';
    $.fn.selectpicker.defaults = {
        selectAllText: "All",
        deselectAllText: "None"
    }
    $('.selectpicker').selectpicker({
        iconBase: 'fa',
        tickIcon: 'fa-check',
        showTick: true,
    });

    $('.datepicker').datepicker(
        {
            format: 'yyyy/mm/dd',
        }
    );
});

$(document).ready(function() {
    styleSidebar();
});

$( window ).resize(function() {
    styleSidebar();
});

function styleSidebar() {
    var screen_height = screen.height;
    if(screen_height < 582) {
        var menu_height = screen_height - 168 - 55 - 28 - 20;
        $(".sidebar-links").css("height", menu_height + 'px');
        $(".sidebar-links").addClass("scrollable");
    } else {
        $(".sidebar-links").css("height", 'auto');
        $(".sidebar-links").removeClass("scrollable");
    }
}
